module.exports = __webpack_public_path__ + "img/Ventilation.b1598195.png";